/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speakers_No_Speakers_FoundInputs */

const en_speakers_no_speakers_found = /** @type {(inputs: Speakers_No_Speakers_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No speakers found`)
};

const fr_speakers_no_speakers_found = /** @type {(inputs: Speakers_No_Speakers_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun intervenant trouve`)
};

const de_speakers_no_speakers_found = /** @type {(inputs: Speakers_No_Speakers_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Lautsprecher gefunden`)
};

const it_speakers_no_speakers_found = /** @type {(inputs: Speakers_No_Speakers_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun relatore trovato`)
};

const ru_speakers_no_speakers_found = /** @type {(inputs: Speakers_No_Speakers_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Динамики не найдены`)
};

const es_speakers_no_speakers_found = /** @type {(inputs: Speakers_No_Speakers_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se encontraron hablantes`)
};

const zh_cn2_speakers_no_speakers_found = /** @type {(inputs: Speakers_No_Speakers_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未找到扬声器`)
};

const ja_speakers_no_speakers_found = /** @type {(inputs: Speakers_No_Speakers_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スピーカーが見つかりません`)
};

const hi_speakers_no_speakers_found = /** @type {(inputs: Speakers_No_Speakers_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कोई स्पीकर नहीं मिला`)
};

const pt_pt2_speakers_no_speakers_found = /** @type {(inputs: Speakers_No_Speakers_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não foram encontrados alto-falantes`)
};

/**
* | output |
* | --- |
* | "No speakers found" |
*
* @param {Speakers_No_Speakers_FoundInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speakers_no_speakers_found = /** @type {((inputs?: Speakers_No_Speakers_FoundInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speakers_No_Speakers_FoundInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_speakers_no_speakers_found(inputs)
	if (locale === "de") return de_speakers_no_speakers_found(inputs)
	if (locale === "it") return it_speakers_no_speakers_found(inputs)
	if (locale === "ru") return ru_speakers_no_speakers_found(inputs)
	if (locale === "es") return es_speakers_no_speakers_found(inputs)
	if (locale === "zh-CN") return zh_cn2_speakers_no_speakers_found(inputs)
	if (locale === "ja") return ja_speakers_no_speakers_found(inputs)
	if (locale === "hi") return hi_speakers_no_speakers_found(inputs)
	if (locale === "pt-PT") return pt_pt2_speakers_no_speakers_found(inputs)
	return en_speakers_no_speakers_found(inputs)
});